import React, { useState } from "react";
import Modal from "react-modal";
import MealsStructure from "../meal/MealsStructure";
import SearchNButtons from "../../common-components/SearchNButtons";
import LightRedBorderedButton from "../../common-components/LightRedBorderedButton";
import AssignDiet from "../diet-dashboard/assign-diet/AssignDiet";

const HeadingFilterAdd = ({
  filterType,
  ddFilters,
  setDdFilters,
  searchFilterApplied,
  onClickSearch,
  handleKeyPress,
  callFunction,
}) => {
  const [dietAssignModal, setDietAssignModal] = useState(false);

  const onCloseModal = () => {
    setDietAssignModal(false);
  };

  return (
    <>
      <Modal
        isOpen={dietAssignModal}
        onRequestClose={onCloseModal}
        contentLabel="Assign Diet Modal"
        ariaHideApp={false}
      >
        <div className="createNewCTOModalContainer">
          <AssignDiet
            onClose={onCloseModal}
            callFunction={callFunction}
            isExternal={true}
          />
        </div>
      </Modal>

      <div className="flexSpacebetween heading-filters-btn mt30">
        <div className="one-part long-one">
          <MealsStructure
            text={`${
              filterType ? filterType?.replace(/_/g, " ") : "All Members"
            }`}
          />

          <SearchNButtons
            pageName={"diet-dashboard"}
            filters={ddFilters}
            setFilters={setDdFilters}
            searchFilterApplied={searchFilterApplied}
            onClickSearch={onClickSearch}
            handleKeyPress={handleKeyPress}
          />
        </div>
        <div className="one-part short-one">
          <LightRedBorderedButton
            btnTxt={"+ Assign diet"}
            onClick={() => setDietAssignModal(true)}
          />
        </div>
      </div>
    </>
  );
};

export default HeadingFilterAdd;
